import React, { FC, memo, useCallback, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import ToolBar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logo from "../../assets/header/logoForHeader.png";
import noAvatorIcon from "../../assets/noAvatar.png";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import imageViews from "../../assets/department/monitoring.png";
import imageSetting from "../../assets/department/torello.png";
import imageDrafts from "../../assets/department/aqua-draft.png";

import Tooltip from "@mui/material/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./Header.module.scss";

import { Divider, IconButton, Menu, MenuItem } from "@mui/material";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import { viewsList } from "../../commons/views";
import { ClosableDrawer } from "../uikit/organisms/ClosableDrawerOfDepartment";
import { ClosableDrawer as ClosableDrawerDepartment } from "../uikit/organisms/ClosableDrawerOfDepartment";
import { useLogout } from "../../hooks/useLogout";
import { foreColor } from "../../commons/colors";
import SwitchMode from "../uikit/atoms/SwitchMode";
import { theme } from "../../theme/theme";
import { AQUA_DRAFTS_BASE_URL } from "../../urls/urls";
type Props = {
  pageTitle: string;
};

export const Header: FC<Props> = (props) => {
  const { pageTitle } = props;
  const user = useRecoilValue(userState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menu, setMenu] = useState();
  const [sideBarOpenDeparment, setSideBarOpenDepartment] = useState(false);
  const { logoutFromGoogleWithResetCache } = useLogout();
  const pathname = useLocation().pathname;
  const navigation = useNavigate();
  // console.log("pathname", pathname);
  const handleLogoClick = (
    e: React.MouseEvent<HTMLElement>,
    isOpen: boolean
  ) => {
    if (!user.isAuth) return;
    navigation("/");
    //スクロールする処理を記述
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    } catch (error) {
      // just a fallback for older browsers
      window.scrollTo(0, 0);
    }
  };

  const handleDrawerToggleViewSets = useCallback(
    (
      event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
      isOpen: boolean
    ) => {
      // console.log("handleDrawerToggleViewSets", user);
      if (!user.isAuth) return;
      // イベントが KeyboardEvent の場合にのみ key プロパティをチェック
      if ("key" in event && (event.key === "Tab" || event.key === "Shift")) {
        return;
      }
      setSideBarOpenDepartment(isOpen);
    },
    [user]
  );
  const handleColumnSetting = () => {
    navigation("/dnd");
  };
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (user?.isAuth) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClickLogOut = () => {
    logoutFromGoogleWithResetCache();
    handleClose();
  };
  const handleClickCardSetting = () => {
    // navigation("/cardSetting");
    handleClose();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className={classes.header}>
      <AppBar position="fixed" className={classes.menuBar}>
        <ToolBar className={classes.toolBar}>
          <img
            src={logo}
            alt="Logo"
            className={classes.logo}
            onClick={(e) => handleLogoClick(e, true)}
          />
          <div className={classes.leftMenuIcons}>
            {user.isAuth && (pathname === "/" || pathname === "/main") && (
              <>
                <div
                  className={classes.sidebarIcon}
                  onClick={(e) => handleDrawerToggleViewSets(e, true)}
                >
                  <Tooltip title="ViewSetting" placement="bottom">
                    <img src={imageViews} alt="" />
                  </Tooltip>
                </div>
                <div
                  className={classes.sidebarIcon}
                  onClick={() => window.open(AQUA_DRAFTS_BASE_URL, "_blank")}
                >
                  <Tooltip title="Drafts" placement="bottom">
                    <img src={imageDrafts} alt="" />
                  </Tooltip>
                </div>
              </>
            )}
          </div>
          {/* <Typography
            variant="h6"
            component="div"
            className={classes.pageTitle}
          >
            {pageTitle}
          </Typography> */}

          <div className={classes.rightMenuIcons}>
            {user.isAuth && (pathname === "/" || pathname === "/main") && (
              <div className={classes.sidebarMenu}>
                <div
                  className={classes.sidebarIcon}
                  onClick={handleColumnSetting}
                >
                  <Tooltip title="ColumnSettings" placement="bottom">
                    <img src={imageSetting} alt="" />
                  </Tooltip>
                </div>
              </div>
            )}
            <div className={classes.vDivider} />
            <div className={classes.userArea}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
              >
                <Typography
                  variant="body1"
                  component="div"
                  className={classes.userName}
                  sx={color(user?.mode ?? "dark")}
                >
                  {user?.isAuth ? user?.workerName : ""}
                </Typography>
                <img
                  src={user?.isAuth ? user?.photoURL : noAvatorIcon}
                  alt=""
                  className={classes.noAvatorIcon}
                />
              </IconButton>
            </div>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              sx={{
                "& .MuiPaper-root": {
                  // Paperコンポーネントに対するスタイル
                  backgroundColor: "#202226",
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "conter",
                  paddingLeft: "10px",
                  marginBottom: "5px",
                }}
              >
                {/* <ListItemIcon> */}
                <ExitToAppIcon style={color(user?.mode ?? "dark")} />
                {/* </ListItemIcon> */}
                <MenuItem
                  onClick={handleClickLogOut}
                  className={classes.logout}
                  style={color(user?.mode ?? "dark")}
                >
                  ログアウト
                </MenuItem>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  marginRight: "20px",
                }}
              >
                <MenuItem style={color(user?.mode ?? "dark")}>モード</MenuItem>
                <SwitchMode />
              </div>
            </Menu>
          </div>
        </ToolBar>
        {/* //要素を追加 */}
      </AppBar>
      <ClosableDrawerDepartment
        viewsList={viewsList}
        open={sideBarOpenDeparment}
        onClose={handleDrawerToggleViewSets}
      />
    </div>
  );
};
const color = (mode: string) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.main //間違いではない。色合いを考慮してdarkColorを指定している
        : theme.palette.darkColor.foreColor.main,
  };
};
